import React from "react";

import PropTypes from "prop-types";

import RbControl from "../RbControl";
import RbRadioGroup from "../RbRadioGroup";

const RbRadioGroupControl = React.forwardRef(function RbRadioGroupControl(
  props,
  ref
) {
  const {
    columnGap,
    gridColumns,
    defaultValue,
    name,
    onChange,
    onChangeValue,
    options,
    rowGap,
    value,
    variant,
    ...other
  } = props;

  return (
    <RbControl
      ref={ref}
      renderComponent={(params) => (
        <RbRadioGroup
          {...params}
          columnGap={columnGap}
          defaultValue={defaultValue}
          name={name}
          onChange={onChange}
          onChangeValue={onChangeValue}
          options={options}
          rowGap={rowGap}
          value={value}
          variant={variant}
          gridColumns={gridColumns}
        />
      )}
      {...other}
    />
  );
});

RbRadioGroupControl.propTypes = {
  columnGap: PropTypes.number,
  gridColumns: PropTypes.number,
  defaultValue: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.number,
    PropTypes.string,
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  rowGap: PropTypes.number,
  value: PropTypes.any,
  variant: PropTypes.oneOf(["column", "row"]),
};

RbRadioGroupControl.defaultProps = {
  columnGap: undefined,
  gridColumns: undefined,
  defaultValue: undefined,
  name: undefined,
  onChange: undefined,
  onChangeValue: undefined,
  options: undefined,
  value: undefined,
  rowGap: undefined,
  variant: undefined,
};

export default React.memo(RbRadioGroupControl);
